<div
  [class]="
    displayObject.disabled ? 'data-table-row-disabled' : 'data-table-row'
  "
  (click)="onSelect($event)"
>
  @for (prop of properties; track prop.property) {
    <div [class]="displayObject.disabled ? 'property-disabled' : 'property'">
      @if (
        displayObject[prop.property] !== true &&
        displayObject[prop.property] !== false
      ) {
        <div class="cell">
          <div class="cell-content">
            <div class="cell-text">
              {{ formatProperty(prop.property, displayObject[prop.property]) }}
            </div>
          </div>
        </div>
      }
      <!-- change image by a checkbox -->
      @if (
        displayObject[prop.property] === true ||
        displayObject[prop.property] === false
      ) {
        <mat-checkbox
          class="cell-content"
          (click)="(displayObject['checked'])"
          [checked]="displayObject[prop.property] ? true : false"
        ></mat-checkbox>
      }
    </div>
  }
</div>
